// @noflow
const toLeft = left => [left, null];
const toRight = right => [null, right];

export default function toResult(fn) {
    function* wrapFunctionWithToResult(...args) {
        try {
            const out = yield fn(...args);
            if (out && out.then) {
                return out.then(toLeft, toRight);
            }

            return toLeft(out);
        } catch (err) {
            return toRight(err);
        }
    }

    return wrapFunctionWithToResult;
}



// WEBPACK FOOTER //
// ./src/core/state/toResult.js